import React, { useState } from 'react';
import { useController, ApplicationView } from '@aha-app/mvc';
import Tool, { type ToolButtonComponent } from './Tool';
import ToolButton from '../toolbars/ToolButton';
import WhiteboardController from '../controllers/WhiteboardController';
import AhaMenu from '../toolbars/AhaMenu';
import trackEvent from '../utils/analytics';

const timescales = ['Auto', 'Quarters', 'Months', 'Weeks', 'Days'];

const TimescalesButton: ToolButtonComponent = ApplicationView(
  ({ selection, forceRecalculate, tool }) => {
    const controller = useController(WhiteboardController);
    const [timescale, setTimescale] = useState(
      selection.firstObject().timescale
    );

    const handleTimescaleChange = (timescale: string) => {
      selection.setOnObjects('timescale', timescale);
      setTimescale(timescale);
      controller.canvas.requestRenderAll();
      trackEvent(
        'Feature-7177137609894815136',
        'User edits timeline resolution',
        {
          resolution: timescale,
        }
      );
    };

    const capitalize = lower => lower[0].toUpperCase() + lower.substring(1);

    return (
      <AhaMenu callback={forceRecalculate}>
        <ToolButton
          style={{ width: 70, paddingLeft: 5, paddingRight: 5 }}
          slot='control'
          tool={tool}
        >
          <div
            style={{
              display: 'flex',
              flex: 1,
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <span style={{ marginRight: 5, fontSize: 13 }}>
              {capitalize(timescale)}
            </span>
            <aha-icon icon='fa fa-solid fa-caret-down' />
          </div>
        </ToolButton>
        <aha-menu-content>
          {timescales.map(t => (
            <aha-menu-item
              key={t}
              onClick={() => handleTimescaleChange(t.toLowerCase())}
              selected={t === capitalize(timescale) ? true : null}
            >
              {t}
            </aha-menu-item>
          ))}
        </aha-menu-content>
      </AhaMenu>
    );
  }
);

class ToolTimescale extends Tool {
  static toolName = 'Timeline view';

  static buttonComponent() {
    return TimescalesButton;
  }
}

export default ToolTimescale;
